import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { inputSliceActions, selectInputImportant, selectIsActiveEventTypeIdImportant } from 'features/input/inputSlice';

import Toggle from 'atoms/Toggle';

import EventButton from 'components/EventButton';
import EventList from 'components/EventList';
import EventInput from 'components/EventInput';

import StyledEventPanel from './StyledEventPanel';
import { MatchEventType } from '../../enums/matchEventType';
import { TeamOption } from '../../enums/teamOption';
import EventTime from '../EventTime';
import EventPanelInput from '../EventPanelInput';
import EventButtonsNoTeam from '../EventButtonsNoTeam';
import EventSummary from '../EventSummary';
import { selectMatchEvents, selectMatchStatusId } from '../../features/match/matchSlice';
import { MatchStatus } from '../../enums/matchStatus';

const EventPanel: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const inputImportant = useSelector(selectInputImportant);
  const isActiveMatchEventImportant = useSelector(selectIsActiveEventTypeIdImportant);
  const matchStatusId = useSelector(selectMatchStatusId);
  const matchEvents = useSelector(selectMatchEvents);

  let penaltiesStarted = false;
  matchEvents.forEach((matchEvent) => {
    if (matchEvent.matchEventTypeId === MatchEventType.PENALTIES) {
      penaltiesStarted = true;
    }
  });

  if (!inputImportant && isActiveMatchEventImportant) {
    dispatch(inputSliceActions.setImportant(true));
  }

  const buttons = (team: TeamOption) => {
    let matchEventTypeIds;
    if (penaltiesStarted && matchStatusId === MatchStatus.PENALTIES) {
      matchEventTypeIds = [MatchEventType.PENALTY, MatchEventType.YELLOW_CARD, MatchEventType.RED_CARD];
    } else if (matchStatusId === MatchStatus.PENALTIES) {
      matchEventTypeIds = [MatchEventType.YELLOW_CARD, MatchEventType.RED_CARD];
    } else {
      matchEventTypeIds = [
        MatchEventType.GOAL,
        MatchEventType.PENALTY,
        MatchEventType.FREE_KICK,
        MatchEventType.YELLOW_CARD,
        MatchEventType.RED_CARD,
        MatchEventType.PLAYER_OFF,
        MatchEventType.CORNER,
        MatchEventType.OFFSIDE,
      ];
    }

    return matchEventTypeIds.map((eventTypeId) => (
      <EventButton key={eventTypeId} matchEventTypeId={eventTypeId} team={team} />
    ));
  };

  return (
    <StyledEventPanel>
      <div className="top">
        <div className="home">{buttons(TeamOption.HOME)}</div>
        <div className="middle">
          <EventButtonsNoTeam matchStatusId={matchStatusId} />
        </div>
        <div className="away">{buttons(TeamOption.AWAY)}</div>
      </div>
      <div className="content">
        <EventInput />
      </div>
      <div>
        <div className="toolbar">
          <div className="left">
            <Toggle
              className="important"
              label={intl.formatMessage({ id: 'toggles.important' })}
              selected={isActiveMatchEventImportant || inputImportant}
              locked={isActiveMatchEventImportant}
              onToggle={() => {
                dispatch(inputSliceActions.setImportant(!inputImportant));
              }}
            />

            <EventTime />
            <EventSummary />
          </div>
        </div>
        <EventPanelInput />
      </div>
      <EventList />
    </StyledEventPanel>
  );
};

export default EventPanel;
